import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Cool = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M14.683 14.828a4.055 4.055 0 01-1.272.858 4.002 4.002 0 01-4.875-1.45l-1.658 1.119a6.063 6.063 0 001.621 1.62 5.963 5.963 0 002.148.903 6.035 6.035 0 003.542-.35 6.048 6.048 0 001.907-1.284c.272-.271.52-.571.734-.889l-1.658-1.119a4.147 4.147 0 01-.489.592z",
    key: "k0"
  }), React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 2c2.953 0 5.531 1.613 6.918 4H5.082C6.469 5.613 9.047 4 12 4zm0 16c-4.411 0-8-3.589-8-8 0-.691.098-1.359.264-2H5v1a2 2 0 002 2h2a2 2 0 002-2h2a2 2 0 002 2h2a2 2 0 002-2v-1h.736c.166.641.264 1.309.264 2 0 4.411-3.589 8-8 8z",
    key: "k1"
  }));
});
Cool.displayName = 'Cool';
export var CoolDimensions = {
  height: 24,
  width: 24
};